module.exports = __webpack_public_path__ + "img/archived-blue.7c9f4d30.svg";